import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { efsTcheckTransaction, fsEFSTchekPaymentAction } from "@mobile-dev/platform/common/redux/actions/EFSTcheckAction";
import React, { useEffect, useState } from 'react';
import { Alert } from "react-bootstrap";
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast } from "react-toastify";
import { AppConstatnt } from "../../../../../Utils/AppConstant";
import { getApplicationFlow, getCarrierEnteredMobileNumber, getTheme, isEclipseOpsTruck, showAlert } from "../../../../../Utils/Utility";
import ErrornDialog from "../../../../Common/ErrorDialog/ErrorDialog";
import LoaderButton from "../../../../Common/LoaderButton";
import TransactionDialog from "../../../../Common/TransactionDialog";
import BilledHeader from "../BilledHeader";
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";

function TCheck({ intl }) {

    const dispatch = useDispatch();
    const location = useLocation();
    const auth = useSelector(state => state.amplifyUser);
    const userData = auth.user.attributes;
    const id = location.state.id;
    const efsTransaction = useSelector(state => state.efsTcheck);
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);
    const load_control_num = load?.load_control_num;
    const warehouse_id = load?.warehouse_id;

    const amount = location.state.amount;
    const originalAmount = location?.state?.originalAmount;

    const remainingAmount = location.state.remainingAmount;
    const bankName = location.state.bankName;
    const selection = location.state.selection;
    const [errorStatus, setErrorStatus] = useState('');
    const [cardNumber, setCardNumber] = useState({ cardVal1: "", cardVal2: "" });
    const [moneyCode, setmoneyCode] = useState({ moneyCodeVal1: "", moneyCodeVal2: "" });
    const [togglebutton, setTogglebutton] = useState(true);
    const [show, setShow] = useState(false);
    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const total_bill_amount = location.state.total_bill_amount;
    const paymentmethods = location.state.paymentmethods;
    const [isDefault, setIsDefault] = useState(false);
    const { formatMessage } = intl;
    const serviceFee = location.state.serviceFee;
    let driver_phone = getApplicationFlow() === 'Carrier' ? getCarrierEnteredMobileNumber() : userData.phone_number;

    useEffect(() => {
        dispatch(clearError());
    }, []);


    useEffect(() => {
        if (moneyCode.moneyCodeVal1) {
            setTogglebutton(false)
        }
        else {
            setTogglebutton(true)
        }
    }, [moneyCode]);

    const onShowAlert = () => {
        setShow(true)
        window.setTimeout(() => {
            setShow(false)
            setIsDefault(false);
        }, 10000)

    }

    useEffect(() => {

        if (efsTransaction?.error?.response?.status === 400) {
            switch (efsTransaction?.error?.response.data.response_reason) {
                case AppConstatnt.tcheck_error_code.AMOUNT_CODE_INVALID:
                    setErrorStatus(AppConstatnt.tcheck_error_response.INVALIDMONEYCODE);
                    break;
                case AppConstatnt.tcheck_error_code.INVALID_MONEY_CODE:
                    setErrorStatus(AppConstatnt.tcheck_error_response.INVALIDMONEYCODE);
                    break;
                case AppConstatnt.tcheck_error_code.EXPRESS_CODE_NOT_ON_FILE:
                    setErrorStatus(AppConstatnt.tcheck_error_response.INVALIDMONEYCODE);
                    break;
                case AppConstatnt.tcheck_error_code.DUPLICATE_INVOICE:
                    setErrorStatus(AppConstatnt.tcheck_error_response.DUPLICATEINVOICE);
                    break;
                case AppConstatnt.tcheck_error_code.AMOUNT_EXCEEDS_BALANCE:
                    setErrorStatus(AppConstatnt.tcheck_error_response.AMOUNTEXCEEDSBALANCE);
                    break;
                default:
                    //setErrorStatus(efsTransaction?.error?.response.data.response_reason)
                    setErrorStatus(formatMessage({ id: "app.error_content" }));
                    setIsDefault(true);
                    break;
            }
            onShowAlert();
        }
        else {
            setShow(false);

        }
    }, [efsTransaction?.error?.response])

    const handleMoneyCodeChange = (e) => {
        setmoneyCode({
            ...moneyCode,
            [e.target.name]: e.target.value
        });
    }


    const handleSubmit = () => {

        const random = Math.floor((Math.random() * (100 - 1) + 1) / 2);
        if (moneyCode.moneyCodeVal1.length === 16 || moneyCode.moneyCodeVal1.length === 24) {
            if (isEclipseOpsTruck(load)) {
                const transactionData = {
                    recID: id,
                    transactionType: "TCHEK_MONEY_CODE",
                    paymentCode: moneyCode.moneyCodeVal1,
                    driverLastName: auth?.user?.attributes?.family_name,
                    driverFirstName: auth?.user?.attributes?.given_name,
                    carrierName: "",
                    fullAmount: amount,
                    driverPhoneNumber: auth?.user?.attributes?.phoneNumber,
                    transactionDateTime: moment(),
                    timeZone: "UTC+6",
                    unitNum: null,
                    tripNum: null,
                    relaySiteId: warehouse_id,
                    tabletype: "eclipseOps",
                    serviceFee: serviceFee,
                    paymentType: selection,
                    user_number: driver_phone,
                }
                dispatch(fsEFSTchekPaymentAction(transactionData))
            } else {
                const transactionRequest = {
                    amount: amount,
                    warehouse_id: warehouse_id,
                    load_id: id,
                    transaction_type: 'TCHEK_MONEY_CODE',
                    money_code: moneyCode.moneyCodeVal1
                }

                dispatch(efsTcheckTransaction(transactionRequest));
            }
        }
        else {
            showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.tcheck_money_code_tooltip" }))
        }



    }

    const handleEmail = () => {
        window.open(`mailto:support@freightsmith.net?subject=${load_control_num}&body=Body%20goes%20here`)
    }

    const getAmount = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(amount) - parseFloat(serviceFee)
        } else {
            return originalAmount
        }
    }

    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="contest_input_block">
                        <BilledHeader path={`/paymentconfirmation/${id}`} amount={getAmount()} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} paymentmethods={paymentmethods} />
                        <div className="container_block" style={{ padding: '40px' }}>
                            <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                                <div className="row">
                                    {show &&
                                        <div className="col-md-8">
                                            <Alert variant="danger" onClose={() => setShow(false)} dismissible >
                                                {isDefault ? <>{errorStatus}<input className="btn-bg-none text-primary" type="button" onClick={handleEmail} value="support@freightsmith.net"></input>{`.Thank you`}</> : errorStatus}
                                            </Alert>
                                        </div>
                                    }
                                </div>
                                <div className="tab-pane">
                                    <section id="T_Check_hide">
                                        <h4 className="mb-3 txtwhite">{formatMessage({ id: "app.tchek_payment" })}</h4>
                                        <p>{formatMessage({ id: "app.total_amount_to_pay" })} <strong
                                            className="remaining_amt">${amount}</strong></p>
                                        <div className="row mt-4">
                                            <div className="col-5">
                                                <div className="form-group">
                                                    <label for="efsMoneycode">{formatMessage({ id: "app.money_code_fuel_card" })}</label>
                                                    <Tooltip title={formatMessage({ id: "app.tcheck_money_code_tooltip" })} enterTouchDelay={0} arrow>
                                                        <input type="text" name="moneyCodeVal1" id="efsMoneycode" data-tip data-for='efsMoneycode'
                                                            className="form-control" placeholder={formatMessage({ id: "app.money_code_fuel_card" })} onChange={handleMoneyCodeChange} />
                                                    </Tooltip>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                            <LoaderButton
                                                className="btn btn-chartreuse justify-content-center "
                                                name={formatMessage({ id: "app.submit" })}
                                                onButtonClick={handleSubmit}
                                                valid={!togglebutton}
                                                loading={efsTransaction?.loading}
                                            />
                                        </div>
                                        {(efsTransaction?.efsTcheckTransaction?.transaction_status || efsTransaction?.efsTcheckTransaction?.status === "closed") && <TransactionDialog
                                            transactionId={efsTransaction?.efsTcheckTransaction?.transaction_status}
                                            statusMessage={`T-Chek ${formatMessage({ id: "app.payment_submitted_successfully" })}`}
                                            open
                                            id={id}
                                            paymentType={AppConstatnt.TCHECK}
                                            message={formatMessage({ id: "app.view_payment_details" })}
                                            amount={amount}
                                            remainingAmount={remainingAmount}
                                            selection={selection}
                                            total_bill_amount={total_bill_amount}
                                            load_control_num={load_control_num}
                                        />}
                                    </section>
                                </div>
                                {efsTransaction?.error && !errorStatus && <ErrornDialog
                                    error="Sorry you are experiencing an unknown issue. For immediate assistance, please contact our Contact Support Center at (855)752-2878 to speak with an agent. Thank you."
                                    open
                                />}
                            </div>
                        </div>
                    </div></div></div>

        </>
    )
}

export default injectIntl(TCheck);